module.exports = __webpack_public_path__ + "img/role-ecommerce.7aae4647.png";